import { render, staticRenderFns } from "./IconTags.vue?vue&type=template&id=3a5be5df&"
import script from "./IconTags.vue?vue&type=script&lang=js&"
export * from "./IconTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5be5df')) {
      api.createRecord('3a5be5df', component.options)
    } else {
      api.reload('3a5be5df', component.options)
    }
    module.hot.accept("./IconTags.vue?vue&type=template&id=3a5be5df&", function () {
      api.rerender('3a5be5df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTags.vue"
export default component.exports